// Re-export types for backward compatibility
export type { Notification, NotificationWithDetails } from '@/contexts/NotificationsContext';

// Re-export the context hook as useNotifications for backward compatibility
import { useNotificationsContext } from '@/contexts/NotificationsContext';

export function useNotifications() {
  return useNotificationsContext();
}
